export class VirtualOperatorEnums {
  static TransferProfile = {
    BLIND: 'BLIND',
    SUPERVISED: 'SUPERVISED',
    CONSULTATION: 'CONSULTATION',
  };

  static GraphType = {
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
    CUSTOM: 'CUSTOM',
  };
}
